import {
  Box,
  Grid,
  SpaceBetween,
  Link,
  Button,
  Icon,
} from "@cloudscape-design/components";

interface HeaderHomePageProps {
  openHelpPanel: (isOpen: boolean) => void;
}


export const HeaderHomePage: React.FC<HeaderHomePageProps> = ({openHelpPanel}) => {
  return (
    <Box data-testid="hero-header" padding={{ top: "xs", bottom: "l" }}>
      <Grid
        gridDefinition={[
          { colspan: { default: 12, xs: 8, s: 9 } },
          { colspan: { default: 12, xs: 4, s: 3 } },
        ]}
      >
        <div>
          <Box variant="h1">Car Collection Dashboard</Box>
          <Box
            variant="p"
            color="text-body-secondary"
            margin={{ top: "xxs", bottom: "s" }}
          >
            A proof of skills project demonstrating interactive data
            visualization and layout customization. Every car shown here is
            served live from a GraphQL API backed by AWS AppSync, Lambda, and
            DynamoDB. The data itself is sample data and is not authoritative.
          </Box>
          <SpaceBetween size="xs">
            <p>
            The side panel on the right side contains more information about the
            dashboard.
            </p>
            <div>
              If closed, click the blue icon to open the side panel <Button iconName="external" variant="inline-icon" onClick={() => openHelpPanel(true)}/>
            </div>
          </SpaceBetween>
        </div>
      </Grid>
    </Box>
  );
};
